<template>
    <div class="automation-block-editor terminate-automation">
        <div class="editor-row customize-editor-minimize">
            <div class="editor-row-title">{{ $t('auto.terminateAutomationTerminateWithSuccess') }}</div>
            <a-switch v-model="clone.success" />
        </div>
        <div class="editor-row customize-editor-minimize" v-if="!clone.success">
            <div class="editor-row-title">{{ $t('auto.terminateAutomationFailReason') }}</div>
            <TiptapEditor
                placeholder="Fail Reason"
                :show-attributes="true"
                :max-character-count="500"
                v-model="clone.failReason"
                automation-mode
                :previewMode="clone.success"
            />
        </div>
    </div>
</template>

<script>
import log2 from "../../../../../../utils/log2";
import _ from "lodash";
import TiptapEditor from "../../../../Chatbot/pages/dashboard/common/TiptapEditor.vue";

const log = log2("TerminateAutomation");
export default {
    name: "TerminateAutomation",
    components: { TiptapEditor },
    props: ["value"],
    data() {
        const clone = _.cloneDeep(this.value) || {
            success: false,
            failReason: "{{system.failReason}}",
        };
        return {
            clone,
        };
    },
    methods: {},
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
    },
};
</script>

<style lang="scss">
.automation-block-editor.terminate-automation {
    padding: 20px;
    display: flex;
    gap: 20px;
    flex-direction: column;

    .editor-row {
        width: 100%;

        .editor-row-title {
            font-weight: bold;
            font-size: 16px;
        }
    }
}
</style>
